import { Action, handleActions } from 'redux-actions'
import { importData, importDataSuccess, importDataFail, clearImportDataResult } from './ImportDataAdminActions'

export interface ImportDataResult {
  totalRows: number
  imported: number
  skipped: number
  errors: { row: number; message: string }[]
}

class State {
  uploading: boolean = false
  result: ImportDataResult | null = null
}

export const importDataAdmin = handleActions<State, any>(
  {
    [String(importData)]: (state: State): State => ({
      ...state,
      uploading: true,
      result: null,
    }),
    [String(importDataSuccess)]: (state: State, action: Action<any>): State => ({
      ...state,
      uploading: false,
      result: action.payload,
    }),
    [String(importDataFail)]: (state: State): State => ({
      ...state,
      uploading: false,
    }),
    [String(clearImportDataResult)]: (state: State): State => ({
      ...state,
      result: null,
    }),
  },
  new State(),
)

export { State as ImportDataAdminState }
